<template>
  <div>
    <portal to="toolbar-title">
      Οικονομικές εκκρεμότητες
    </portal>
    <portal to="toolbar-actions">

    </portal>
    <single-page>
      <template v-slot:toolbar-title>
        Ανα κτήριο
      </template>
      <template v-slot:toolbar-items>
        <v-btn class="mr-3" outlined  color="primary"  @click="exportToExcel('Οικονομικές Εκκρεμότητες')">
          <v-icon> mdi-file-excel</v-icon>
          ΛΗΨΗ EXCEL
        </v-btn>
        <v-btn v-if="userDetails.Allows.AllowPayments" color="success" to="/financial/dept/payments" > ΠΛΗΡΩΜΗ
        </v-btn>
      </template>
      <template v-slot:main-sidebar>
        <div class="pa-3">
          <filters module-name="OpenDeptsHandler"/>
        </div>
      </template>
      <template v-slot:main-content>
        <dept-overview class="mb-4" hide-buttons hide-details hide-title></dept-overview>
        <active-filters module-name="OpenDeptsHandler"/>
        <v-data-iterator
            :group-by="['PartnerBrandName']"
            :items="data"
            hide-default-footer
            disable-pagination
            no-data-text="Δεν υπάρχουν οικονομικές εκκρεμότητες"
        >
          <template v-slot:default="props">
            <template v-if="!props.groupedItems.length && props.items">
              <v-row dense>
                <v-col
                    v-for="item in props.items"
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                    xl="3"
                >
                  <dept-item show-brand-name :dept="item"/>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-expansion-panels multiple :value="[0]">
                <v-expansion-panel v-for="group in props.groupedItems">
                  <v-expansion-panel-header class="pa-0">
                    <v-list-item>
                      <v-list-item-content>
                        {{ group.name }}
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text> Yπόλοιπο</v-list-item-action-text>
                        <span
                            style="font-size: 1.2em">{{
                            group.items.map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) - group.items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) | fixed
                          }}‎€ </span>
                      </v-list-item-action>
                      <v-list-item-action>
                        <v-list-item-action-text> Αναμονή</v-list-item-action-text>
                        <span
                            style="font-size: 1.2em">{{
                            group.items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) |fixed
                          }}‎€ </span>
                      </v-list-item-action>
                    </v-list-item>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager class="ma-0 pa-0">
                    <v-list style="overflow-y: auto" v-if="isMobile">
                      <dept-item class="pa-0" v-for="item in group.items" show-brand-name :dept="item"/>
                    </v-list>
                    <v-data-table v-if="!isMobile" id="table" :headers="headers" :items="group.items"
                                  disable-pagination
                                  hide-default-footer fixed-header
                                  style="max-height:60vh; overflow-y: auto;"
                                  no-data-text="Δεν υπάρχουν οικονομικές εκκρεμότητες"
                    >
                      <template v-slot:item.Description="{item}">
                        {{ item.Description }}
                        <br/>
                        <span style="color:green;"
                              v-if="item.PendingAmount"> Αναμονή έκγρισης πληρωμής: {{ item.PendingAmount }} €</span>
                      </template>
                      <template v-slot:item.NumberPar="{item}">
                        <div v-if="item.NumberPar">{{ item.NumberPar }}</div>
                        <div v-else>
                          <v-chip> Σε αναμονή</v-chip>
                        </div>
                      </template>
                      <template v-slot:item.Balance="{item}">
                        <div class="text-center faded font-weight-medium pa-1"
                             style="border-radius: 15px;">
                          {{ item.Balance | fixed }}‎€
                        </div>
                      </template>
                      <template v-slot:item.DateInvoice="{item}">
                        {{ item.DateInvoice | fullDate }}
                      </template>

                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </template>
          </template>
        </v-data-iterator>
        <v-data-table style="display:none;" id="table" :headers="headers" :items="data" :group-by="['PartnerBrandName']"
                      disable-pagination
                      hide-default-footer fixed-header height="70vh"
                      no-data-text="Δεν υπάρχουν οικονομικές εκκρεμότητες"
        >
          <template v-slot:group.header="{items,group}">
            <td colspan="5" class="text-start">
              <v-list-item dense>
                <v-list-item-content>
                  <v-list-item-title class="text--black">
                    {{ group }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-list-item-action-text> Υπόλοιπο</v-list-item-action-text>
                  <span
                      style="font-size: 1.4em">{{
                      items.map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) - items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) | fixed
                    }}‎€ </span>
                </v-list-item-action>
                <v-list-item-action>
                  <v-list-item-action-text> Σε Αναμονή</v-list-item-action-text>
                  <span style="font-size: 1.4em">{{
                      items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) | fixed
                    }}‎€ </span>
                </v-list-item-action>
              </v-list-item>
            </td>
          </template>
          <template v-slot:item.Description="{item}">
            {{ item.Description }}
            <br/>
            <span style="color:green;"
                  v-if="item.PendingAmount"> Αναμονή έκγρισης πληρωμής: {{ item.PendingAmount }} €</span>
          </template>
          <template v-slot:item.NumberPar="{item}">
            <div v-if="item.NumberPar">{{ item.NumberPar }}</div>
            <div v-else>
              <v-chip> Σε αναμονή</v-chip>
            </div>
          </template>
          <template v-slot:item.Balance="{item}">
            <div class="text-center faded font-weight-medium pa-1"
                 style="border-radius: 15px;">
              {{ item.Balance | fixed }}‎€
            </div>
          </template>
          <template v-slot:item.DateInvoice="{item}">
            {{ item.DateInvoice | fullDate }}
          </template>

        </v-data-table>
      </template>
    </single-page>

  </div>


</template>

<script>
import {mapGetters, mapMutations, mapActions} from "vuex";
import store from "../../../store";
import dataGridHandler from "../../../wl-datagrid-handler/dataGridHandler";
import DeptItem from "../components/DeptItem";
import Filters from "../../../wl-datagrid-handler/Filters";
import ActiveFilters from "../../../wl-datagrid-handler/ActiveFilters";
import FiltersModal from "../../../wl-datagrid-handler/FiltersModal";
import DeptOverview from "../components/DeptOverview";
import Page from "../../../components/templates/Page";
import SinglePage from "../../../components/templates/SinglePage";

export default {
  name: "DeptsMobile",

  data: () => ({
    headers: [

      {
        text: 'Hμ/νια ',
        value: 'DateInvoice',
        filterable: true,
        width: "100"
      },
      {
        text: '# Παρ.',
        value: 'NumberPar',
        filterable: true,
        width: "50"
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },
      {
        text: 'Κτήριο',
        value: 'FullBranch',
        filterable: true,
        width: "200"
      },

      {
        text: 'Πελάτης',
        value: 'PartnerBrandName',
      },

      {
        text: 'Ποσό',
        value: 'Balance',
        filterable: true,
        width: "100"
      },
    ]
  }),
  components: {SinglePage, Page, DeptOverview, FiltersModal, ActiveFilters, Filters, DeptItem},
  computed: {
    ...mapGetters('OpenDeptsHandler', [
      "data"
    ]),
    ...mapGetters([
      "isMobile",
      "openDepts",
      "userDetails",
      "totalDept",
      "totalDeptStandBy"
    ])
  },
  methods: {
    ...mapActions([
      "getOpenDepts",
      "getPartnerDetails",
      "exportToExcel"
    ]),
    ...mapMutations('OpenDeptsHandler', [
      "setData",
      "createFilters",
    ]),
    ...mapMutations([
      "showLoading",
      "setLoadingMessage",
      "hideLoading",
    ])
  },
  beforeCreate() {
    store.registerModule('OpenDeptsHandler', dataGridHandler);
  },
  created() {
    this.showLoading();
    this.setLoadingMessage("Ψάγνουμε για οφειλές");
    this.getPartnerDetails().then(
        () => this.getOpenDepts({}).then(openDepts => {
          this.setData(openDepts);
          this.createFilters([
            {
              unique: true,
              key: 'StatusName',
              name: 'Κατάσταση'
            },
            {
              key: 'PartnerBrandName',
              name: 'Έχει χρεωθεί σε'
            },

            {
              key: 'NumberPar',
              name: 'Παραστατικό'
            },

          ]);
          this.hideLoading();
        })
    )
  },
  beforeDestroy() {
    this.$store.unregisterModule('OpenDeptsHandler');
  },
}
</script>

<style scoped>
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
